export const SLUGS = [
    "es/city-hall",
    "es/bear-flag-monument",
    "es/mission-solano",
    "es/blue-wing-inn",
    "es/the-barracks",
    "es/swiss-hotel",
    "es/sonoma-plaza-saloons",
    "es/chinese-sonoma",
    "es/the-duck-pond",
    "es/bill-lynch"
  ]

export const BANNER = [
    ["¿Por qué una plaza aquí?","Camina hasta el punto de partida"],
    ["Monumento a la Bandera del Oso","Camina hasta la siguiente ubicación"],
    ["Mission Solano","Camina hasta la siguiente ubicación"],
    ["Blue Wing Inn","Camina hasta la siguiente ubicación"],
    ["Salomón Schocken", "Camina hasta la siguiente ubicación"],
    ["el hotel suizo", "Camina hasta la siguiente ubicación"],
    ["Hotel Eldorado", "Camina hasta la siguiente ubicación"],
    ["El Sonoma Chino", "Camina hasta la siguiente ubicación"],
    ["El Lago de Patos", "Camina hasta la siguiente ubicación"],
    ["Bill Lynch", "Camina hasta la siguiente ubicación"]
  ]

  export const NARRATIONS = [
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Why%20a%20plaza%20here%20Spanish%20Audio.mp3?alt=media&token=c515f090-63ea-4a3a-a157-16ee8cfb5639",
    "",
    // "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Blue%20Wing%20Spanish%20Audio%20mp3.mp3?alt=media&token=0fc5f9b1-e677-47e5-b2b5-b2392cdebebc",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Mission%20spanish%20audio.mp3?alt=media&token=33e8e140-616c-4c06-a4cc-92a7cd765250",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Blue%20Wing%20Spanish%20with%20music%208-3-22.mp3?alt=media&token=fe95eea1-8ae9-4626-bbfa-fa52ba9a88c7",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Solomon%20Schocken%20Spanish%20Audio.mp3?alt=media&token=f5336fcd-98c4-43f6-b673-0a46d4101e5d",
    "",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Saloon%20Spanish%20Audio.mp3?alt=media&token=29c55666-cf4e-411e-b13b-a1ce6197f020",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Chinese%20community%20Spanish.mp3?alt=media&token=bf71c58e-515f-4e93-935b-a03cda3d56b8",
    "",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Bill%20lynch%20starts%20here%20Spanish%20audio%20mixed%207-19-2022.mp3?alt=media&token=8ef039d1-9500-47f6-aa3f-904db4711a75"
  ]

export const NEXT_STOPS = [
    "Monumento a la Bandera del Oso",
    "Misión en el Parque Histórico Estatal de Sonoma",
    "Blue Wing Inn",
    "Los Cuarteles",
    "Los Bares de la Plaza de Sonoma",
    "salones sonoma plaza",
    "El Sonoma Chino",
    "El Lago de Patos",
    "Bill Lynch"
  ]

  export const INFO1 = [];

  export const INFOS = [
    [
      {
        location: 'Ayuntamiento de Sonoma'
      },
      {
        title: "¿Por qué una Plaza aquí?",
        pt: 3
      },
      {
        subTitle: "Una historia en el cuartel",
      },
      {
        p: `La Plaza sucedió por casualidad, la plaza histórica más grande
        de California ha sido el foco de una planificación deliberada.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/1.png",
          mobileUrl: "../../../assets/stop1/1.png",
          footnote: "Imágenes aéreas de Sonoma Plaza",
          alt: "Imágenes aéreas de Sonoma Plaza"
        },
        pt: 3
      },
      {
        timebar: {
          date: "1830's",
          title: "El cierre de las misiones"
        },
        pt: 3
      },
      {
        p: `<b>México cerró las 21 misiones de la Alta California</b>y declaró que
        todos los bienes de la iglesia fueran entregados al Gobierno mexicano.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/clickable1-sm.png",
          mobileUrl: "../../../assets/stop1/clickable1-sm.png",
          footnote: "Misiones de Alta California",
          alt: "Misiones de Alta California"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/2.png",
          mobileUrl: "../../../assets/stop1/2.png",
          footnote: "Ilustraciones de la Misión Sonoma por Robert Smilie (1975)",
          alt: "Ilustraciones de la Misión Sonoma por Robert Smilie (1975)"
        },
        pt: 3
      },
      {
        timebar: {
          date: "1833",
          title: "General Vallejo"
        },
        pt: 3
      },
      {
        p: `<b>El general Mariano Vallejo llega a Sonoma</b>`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/3.png",
          mobileUrl: "../../../assets/stop1/3.png",
          footnote: "Retrato del general Mariano Vallejo",
          alt: "Retrato del general Mariano Vallejo"
        },
        pt: 3
      },
      {
        list: {
          title: "Órdenes de Vallejo:",
          values: [
            "Establecer un puesto militar",
            "Promover el asentamiento",
            "Desarrollar un pueblo"
          ]
        }
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/4.png",
          mobileUrl: "../../../assets/stop1/4.png",
          footnote: "“Detalle de Vista del Presidio de San Francisco” de Louis Choris (1816). Biblioteca Cortesía de Bancroft",
          alt: "“Detalle de Vista del Presidio de San Francisco” de Louis Choris (1816). Biblioteca Cortesía de Bancroft"
        },
        pt: 3
      },
      {
        timebar: {
          date: "1835",
          title: "Las nuevas leyes"
        },
        pt: 3
      },
      {
        p: `Las Leyes de Indias regularon las colonias españolas durante siglos.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/5.png",
          mobileUrl: "../../../assets/stop1/5.png",
          footnote: " Leyes de Indias",
          alt: " Leyes de Indias"
        },
        pt: 3
      },
      {
        p: `<b>La Plaza,</b> establecida por el general Vallejo, sería el <b>punto de
        partida</b> de estas nuevas leyes bajo un gobierno independiente de México.`,
        pt: 3
      },
      {
        timebar: {
          date: "1835",
          title: "Construyendo una ciudad"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/6.png",
          mobileUrl: "../../../assets/stop1/6.png",
          footnote: "Guillermo Richardson",
          alt: "Guillermo Richardson"
        },
        pt: 3
      },
      {
        p: `El amigo inglés William Richardson extendió la calle de tierra áspera frente a
        la Misión y estableció otra en ángulo recto norte y sur. Las llamaron "Calle Vallejo"
        y "Calle Cuartel", ahora conocidas como Calle España y Primera Calle Este. `,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/7.png",
          mobileUrl: "../../../assets/stop1/7.png",
          footnote: "Fotos del el inicio de la plaza",
          alt: "Fotos del el inicio de la plaza"
        },
        pt: 3
      },
      {
        p: `Desde esa esquina, la plaza y la ciudad fueron finalmente dispuestas.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/8.png",
          mobileUrl: "../../../assets/stop1/8.png",
          footnote: "Mapa del seguro contra incendios de Sanborn de la década de 1880.",
          alt: "Mapa del seguro contra incendios de Sanborn de la década de 1880."
        },
        pt: 3
      },
      {
        timebar: {
          date: "Adelante",
          title: "La visión y el hoy"
        },
        pt: 3
      },
      {
        p: `Las Leyes concibieron la plaza como un lugar donde la gente "podría ir
        a recrearse" y "pastar su ganado". `,
        pt: 3
      },
      {
        double_img: {
          desktopUrl_a: "../../../assets/stop1/9.png",
          mobileUrl_a: "../../../assets/stop1/9.png",
          footnote_a: `Vacas "Cortesía de Oak Hill Farms"`,
          alt_a: `Vacas "Cortesía de Oak Hill Farms"`,
          desktopUrl_b: "../../../assets/stop1/10.png",
          mobileUrl_b: "../../../assets/stop1/10.png",
          footnote_b: "Pollos",
          alt_b: "Pollos"
        },
        pt: 4
      },
      {
        p: `En aquellos días, la gente podría haber hecho un picnic junto a vacas de
        pastoreo. Más recientemente, gallos y gallinas de corral corrieron por la plaza.`,
        pt: 3
      },
      {
        p: `Los tiempos han cambiado, pero la recreación en la Plaza de Sonoma todavía
        tiene influencia--para los humanos y probablemente también para los patos.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/11.png",
          mobileUrl: "../../../assets/stop1/11.png",
          footnote: "Frente al Ayuntamiento, los patos juegan en la fuente con los espectadores",
          alt: "Frente al Ayuntamiento, los patos juegan en la fuente con los espectadores"
        },
        pt: 3
      },
      {
        quiz: {
          question: "¿Qué pájaros ves en la plaza?",
          choices: [
            {
              choice: "Pingüinos",
              answer: false
            },
            {
              choice: "Águilas",
              answer: false
            },
            {
              choice: "Patos",
              answer: true
            }
          ]
        }
      }
    ],
    [
      {
        timebar: {
          date: "1846",
          title: "Día de junio"
        },
        pt: 3
      },
      {
        p: `Este monumento recuerda el día de junio de 1846 cuando 
        <b>una banda de norteamericanos capturó el pueblo mexicano</b>
        sin luchar y luego declaró un territorio independiente que llamaron
        la <b>República de la Bandera del Oso.</b>`,
        pt: 3
      },
      {
        p: `Esto duró solo <b>25 días</b> antes de que llegaran los soldados norteamericanos,
        un regimiento de la guerra entre México y los Estados Unidos.`
      },
      {
        p: `La Revuelta de la Bandera del Oso representa un controvertido punto
        de inflexión en la historia de Sonoma.`
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop2/1.png",
          mobileUrl: "../../../assets/stop2/1.png",
          footnote: "Imagen de la bandera del estado de California, “la bandera del oso”",
          alt: "Imagen de la bandera del estado de California, “la bandera del oso”"
        },
        pt: 3
      },
      {
        p: `Si bien la república fue de corta duración, <b>la Bandera del Oso permanece
        como la bandera del estado de California desde su adopción en 1911.</b>`,
        pt: 3
      },
    ],
    [
      {
        location: 'Parque histórico estatal de Sonoma'
      },
      {
        timebar: {
          date: "1823",
          title: "Fundada por México"
        },
        pt: 2
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop3/1.png",
          mobileUrl: "../../../assets/stop3/1.png",
          footnote: "Bandera mexicana",
          alt: "Bandera mexicana"
        },
        pt: 5
      },
      {
        p: "La Misión San Francisco Solano fue la única misionera <b>fundada por México.</b>",
        pt: 3
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop3/2.png",
          mobileUrl: "../../../assets/stop3/2.png",
          footnote: "Foto de la bandera española",
          alt: "Foto de la bandera española"
        },
        pt: 4
      },
      {
        p: "Las 20 Misiones originales fueron fundadas por <b>misioneros españoles.</b>",
        pt: 3
      },
      {
        title: "El Camino Real",
        pt: 3
      },
      {
        p: "San Francisco Solano era el extremo norte de El Camino Real. El camino del rey que se extendía hasta San Diego.",
        pt: 4
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/4.png",
          mobileUrl: "../../../assets/stop3/4.png",
          footnote: "Mapa de 21 misiones - Zoomed into Northern Frontier",
          alt: "Mapa de 21 misiones - Zoomed into Northern Frontier"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/3.png",
          mobileUrl: "../../../assets/stop3/3.png",
          footnote: "Mapa de 21 misiones",
          alt: "Mapa de 21 misiones"
        },
        pt: 4
      },
      {
        timebar: {
          date: "Anteriormente",
          title: "Tribus nativas"
        },
        pt: 3
      },
      {
        p: `La historia se remonta mucho más atrás entre las personas
        que vivieron en el Valle de Sonoma durante más de 10,000 años,
        una comunidad de nativos <b>coast miwok, pomo, wappo y wintun.</b>`,
        pt: 3
      },
      {
        double_img: {
          desktopUrl_a: "../../../assets/stop3/5a.png",
          mobileUrl_a: "../../../assets/stop3/5a.png",
          footnote_a: "Una chica Pomo. por Edward S. Curtis. 1924",
          alt_a: "Una chica Pomo. por Edward S. Curtis. 1924",
          desktopUrl_b: "../../../assets/stop3/5b.png",
          mobileUrl_b: "../../../assets/stop3/5b.png",
          footnote_b: "Un hombre Wappo. por Edward S. Curtis. 1924",
          alt_b: "Un hombre Wappo. por Edward S. Curtis. 1924"
        },
        pt: 4
      },
      {
        timebar: {
          date: "1823-1834",
          title: "Misión Solano"
        },
        pt: 3
      },
      {
        p: `La Misión Solano duró solo <b>11 años</b>, pero tuvo un
        efecto duradero, no solo en los nativos originales de Sonoma,
        sino aún hoy. La misión plantó las primeras vides en lo que
        ahora se conoce como "Región Vinícola".`,
        pt: 4
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/6.png",
          mobileUrl: "../../../assets/stop3/6.png",
          footnote: "Dos copas de vino sobre un viñedo pintoresco.",
          alt: "Dos copas de vino sobre un viñedo pintoresco."
        },
        pt: 4
      },
      {
        title: "¿Por qué y cómo terminó?",
        pt: 3
      },
      {
        p: `La respuesta corta es la política. El gobierno mexicano,
        recientemente independiente de España, cerró todas las 21
        misiones de Alta California. `,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/7.png",
          mobileUrl: "../../../assets/stop3/7.png",
          footnote: "Independencia de México",
          alt: "Independencia de México"
        },
        pt: 0
      },
      {
        timebar: {
          date: "1835",
          title: "Misión Solano"
        },
        pt: 4
      },
      {
        p: `Nuestra historia local gira en torno a la llegada del
        <b>general Mariano Vallejo</b> y un contingente de soldados del
        presidio de San Francisco.`,
        pt: 4
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop3/8.png",
          mobileUrl: "../../../assets/stop3/8.png",
          footnote: "Retrato del general Mariano Vallejo",
          alt: "Retrato del general Mariano Vallejo"
        },
        pt: 3
      },
      {
        p: `Sus órdenes eran <b>cerrar la Misión Solano</b> y distribuir
        sus activos incluyendo a los casi <b>900 indios del Área de la
        Bahía</b> que fueron esencialmente esclavizados aquí. Así no es
        como funcionaron las cosas, como escucharás más adelante.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/9.png",
          mobileUrl: "../../../assets/stop3/9.png",
          footnote: "Indios del área de la Bahía de San Francisco. Por Louis Choris (1816)",
          alt: "Indios del área de la Bahía de San Francisco. Por Louis Choris (1816)"
        },
        pt: 4
      },
      {
        title: "Honrando a las tribus originales",
        pt: 3
      },
      {
        p: `Antes de salir de Mission Solano, visita el monumento de
        granito, el único de su tipo en California. Honra a los pueblos
        coast miwok, pomo, wappo y wintun que fueron bautizadas,
        recibieron nombres cristianos y fueron enterradas aquí. Sus
        descendientes aún viven aquí.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/10.png",
          mobileUrl: "../../../assets/stop3/10.png",
          footnote: "Monumento de granito en honor a los pueblos coast miwok, pomo, wappo y wintun.",
          alt: "Monumento de granito en honor a los pueblos coast miwok, pomo, wappo y wintun."
        },
        pt: 2
      },
      {
        reflection: {
          title: "Visita el Monumento al Granito",
          p: `Camina hacia el lado izquierdo del edificio para visitar
          el monumento. Este monumento honra a las tribus originales.
          Toca sus nombres, léelos en voz alta.`
        },
        pt: 4
      }
    ],
    [
      {
        subTitle: 'Posada del ala azul'
      },
      {
        p: '<b>Si estas paredes pudieran hablar</b>'
      },
      {
        p: 'La Plaza no surgió por casualidad, la plaza histórica más grande de California ha sido el centro de una planificación deliberada.',
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop4/1.png",
          mobileUrl: "../../../assets/stop4/1.png",
          footnote: "Tertulia de Pulquería (1851) por Agustín Arrieta",
          alt: "Tertulia de Pulquería (1851) por Agustín Arrieta"
        },
        pt: 4
      },
      {
        timebar: {
          date: "Década de 1830",
          title: "Comenzó como un hogar"
        },
        pt: 4
      },
      {
        p: "El edificio data de la década de 1830. Era el hogar de un supervisor en la misión.",
        pt: 2
      },
      {
        timebar: {
          date: "1837",
          title: "El primer salón"
        },
        pt: 2
      },
      {
        p: "Antonio Ortega abrió el primer salón del pueblo, Pulqueria.",
        pt: 1
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop4/2.png",
          mobileUrl: "../../../assets/stop4/2.png",
          footnote: "7 bebidas de Pulque",
          alt: "7 bebidas de Pulque"
        },
        pt: 2
      },
      {
        timebar: {
          date: "1849",
          title: "La fiebre del oro"
        },
        pt: 3
      },
      {
        p: `Los norteamericanos compraron el salón justo antes
        de la fiebre del oro y le sacaron ganancia destinándolo
        como el nuevo bebedero para los mineros de oro.`,
        pt: 2
      },
      {
        double_img: {
          desktopUrl_a: "../../../assets/stop4/3a.png",
          mobileUrl_a: "../../../assets/stop4/3a.png",
          footnote_a: "Mineros de oro",
          alt_a: "Mineros de oro",
          desktopUrl_b: "../../../assets/stop4/3b.png",
          mobileUrl_b: "../../../assets/stop4/3b.png",
          footnote_b: "",
          alt_b: "Mineros de oro"
        },
        pt: 3
      },
      {
        title: "Eran tiempos legendarios.",
        pt: 1
      },
      {
        p: "El Blue Wing cambió de dueños con frecuencia a lo largo de los años.",
        pt: 2
      },
      {
        zoom: {
          size: "lg",
          desktopUrl: "../../../assets/stop4/4.png",
          mobileUrl: "../../../assets/stop4/4.png",
          footnote: "Arriba en el Blue Wing",
          alt: "Arriba en el Blue Wing"
        },
        pt: 2
      },
      {
        timebar: {
          date: "Década de 1900",
          title: "Augistino Pinelli"
        },
        pt: 4
      },
      {
        p: 'retrato de Agosto Pinelli',
        pt: 2
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop4/6.png",
          mobileUrl: "../../../assets/stop4/6.png",
          footnote: "Press Democrat, Volume XXXVIII, Number 221, 20 September 1911",
          alt: "Press Democrat, Volume XXXVIII, Number 221, 20 September 1911"
        },
        pt: 4
      },
      {
        p: "Recorte de periódico antiguo destacando los incendios en 1911",
        pt: 1
      },
      {
        timebar: {
          date: "Forward",
          title: "Mr Sonoma"
        },
        pt: 4
      },
      {
        p: 'Esta familia era tan famosa que la gente del pueblo apodó a su hijo August Pinelli, Mr Sonoma.',
        pt: 2
      },
      {
        img: {
          size: "md",
          desktopUrl: "../../../assets/stop4/5.png",
          mobileUrl: "../../../assets/stop4/5.png",
          footnote: "Agosto Pinelli",
          alt: "Agosto Pinelli"
        },
        pt: 3
      },
      {
        h1: 'Lo llamaban <b>"Sr. Sonoma".</b>',
        pt: 2
      },
      {
        p: "El edificio Pinelli, que sobrevivió al incendio, está a la vuelta de la esquina en <b> 408 1st Street East. </b>",
      },
      {
        timebar: {
          date: "Actual",
          title: "Cerrado"
        },
        pt: 4
      },
      {
        p: `El Blue Wing Adobe es parte del Parque Histórico Estatal
        de Sonoma. Ha estado cerrado durante casi 20 años. Sobre el
        nombre, <b>nadie sabe por qué se llama Blue Wing Inn. Te invito
        a inventar tu propia historia.</b>`,
        pt: 3
      },
      {
        reflection: {
          title: `¿Puedes encontrar <b>los edificios de</b> adobe?`,
          p: `El Blue Wing Inn está construido con ladrillos de adobe.
          Busca otros edificios de adobe alrededor de la Plaza.`
        },
        pt: 3
      },
      {
        test: {
          question: `¿Qué se usó para salvar a Sonoma y al Blue Wing Inn
          de un terrible incendio?`,
          answer: "Vino rojo de August Pinelli"
        },
        pt: 4
      }
    ],
    [
      {
        location: "los cuarteles",
        pt: 3
      },
      {
        title: "Colina de Schocken",
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/1.png",
          mobileUrl: "../../../assets/stop5/1.png",
          footnote: "Foto de  los antiguos cuarteles con la Colina de Schocken al fondo",
          alt: "Foto de  los antiguos cuarteles con la Colina de Schocken al fondo"
        },
        pt: 2
      },
      {
        lgTxt: {
          p: "La cordillera lleva el nombre de <b>Solomon Schocken.</b>",
          dark: false,
          py: 3
        },
        pt: 1
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/2.png",
          mobileUrl: "../../../assets/stop5/2.png",
          footnote: "Retrato remasterizado digitalmente de Solomon Schocken",
          alt: "Retrato remasterizado digitalmente de Solomon Schocken"
        },
        pt: 2
      },
      {
        timebar: {
          date: "1860",
          title: "Nacido en Polonia"
        },
        pt: 3
      },
      {
        p: "Solomon Schocken, un hombre judío, se convirtió en el primer residente judío de Sonoma.",
        pt: 3
      },
      {
        timebar: {
          date: "1873",
          title: "Tienda Schocken"
        },
        pt: 3
      },
      {
        p: `Abrió una tienda en el Hotel Toscano. Sus bajos precios pusieron celosos
        a otros comerciantes de plaza, por lo que lo hicieron arrestar por hacer
        negocios el sábado.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/3.png",
          mobileUrl: "../../../assets/stop5/3.png",
          footnote: "Boceto del Hotel Toscano",
          alt: "Boceto del Hotel Toscano"
        },
        pt: 2
      },
      {
        p: `Schocken intentó de nuevo permanecer abierto los domingos, <b>"sábado judío"</b>.
        Pero pronto se enteró de que la ley no se dejaría persuadir.`,
        pt: 3
      },
      {
        timebar: {
          date: "1878",
          title: "Los cuarteles"
        },
        pt: 4
      },
      {
        p: `Schocken llegó a <b>un acuerdo</b> con el <b>general Vallejo</b> y <b>compró</b> el
        <b>cuartel</b> que se convirtió en <b>la nueva ubicación</b> de su <b>tienda.</b>`,
        pt: 2
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/4.png",
          mobileUrl: "../../../assets/stop5/4.png",
          footnote: "Fotografía de la tienda Schocken",
          alt: "Fotografía de la tienda Schocken"
        },
        pt: 4
      },
      {
        lgTxt: {
          p: `Schocken fue llamado <b>"el comerciante más justo que Sonoma haya tenido".</b>`,
          dark: true,
          py: 4
        },
        pt: 2
      },
      {
        p: `Abrió <b>el primer aserradero de Sonoma</b> y finalmente <b>suministró agua y
        electricidad a la ciudad.</b>`,
        pt: 4
      },
      {
        timebar: {
          date: "1892",
          title: "El negocio de las canteras"
        },
        pt: 3
      },
      {
        p: `Schocken compró lo que ahora se conoce como la Colina Schocken y empleó
        a inmigrantes italianos para cortar <b>adoquines</b> para las <b>calles de
        San Francisco.</b>`,
        pt: 3
      },
      {
        p: `<b>Samuele Sebastiani</b> acarreó adoquines para Schocken hasta que
        ahorró lo suficiente para comenzar su negocio de vinos.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/5.png",
          mobileUrl: "../../../assets/stop5/5.png",
          footnote: "Una foto de Samuele Sebastiani, fundador y propietario de Sebastiani Winery",
          alt: "Una foto de Samuele Sebastiani, fundador y propietario de Sebastiani Winery"
        },
        pt: 3
      },
      {
        p: `Schocken también ayudó al <b>Club de Mujeres</b> a embellecer la Plaza y sirvió en el
        Concejo Municipal.
        <br>
        Su generosidad fue recordada con cariño. Cuando los niños entraban en su tienda, él
        sacaba dulces para ellos de un gran frasco.
        <br>
        Ayudó a muchas personas en tiempos difíciles. Se dijo que <b>incluso Vallejo habría pasado
        hambre sin Schocken.</b>`,
        pt: 3
      },
      {
        test: {
          question: "¿Dónde estuvo la <b>primera tienda de</b> Solomon <b>Schocken?</b>",
          answer: "El hotel Toscano"
        },
        pt: 5
      }
    ],
    [{
      videoplay: {
        title: "Esta parada incluye reproducción de video.",
        p: "Tenga en cuenta su entorno mientras mira.",
        videoTitle: "Entrevista con Hank Marioni",
        videoContent: "Disfrute de una entrevista grabada con Hank Marioni mientras comparte historias y fotos de este establecimiento clásico de Sonoma.",
        videoFooter: "Vídeo: Entrevista con Hank Marioni",
        videoImageLink: '../../../assets/stop6/1.png',
        videoLink: 'https://www.youtube.com/embed/w38fFtXP01Q'
      },
      pt: 3
    },
    {
      quiz: {
        question: "¿En que pais esta Ticino?",
        choices: [
          {
            choice: "Estados Unidos",
            answer: false
          },
          {
            choice: "China",
            answer: false
          },
          {
            choice: "Suiza",
            answer: true
          }
        ]
      }
    }
    ],
    [
      {
        location: 'Hotel Eldorado'
      },
      {
        title: 'Sonoma ha sido un pueblo de bebedores por casi 200 años.',
        pt: 3,
      },
      {
        p: `Similar a la actualidad, el alcohol es una de las atracciones originales de Sonoma.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/1.png',
          mobileUrl: '../../../assets/stop7/1.png',
          footnote: 'Imagen aérea de la Plaza de  Sonoma',
          alt: 'Imagen aérea de la Plaza de  Sonoma',
        },
        pt: 3,
      },
      {
        timebar: {
          date: '1851',
          title: 'El Primer Bar',
        },
        pt: 3,
      },
      {
        p: `El primer abrevadero de nuestro pueblo comenzó como una casa pero pronto se convirtió en una pulquería llamada <b>Blue Wing Inn.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/2.png',
          mobileUrl: '../../../assets/stop7/2.png',
          footnote: 'Fachada exterior del Blue Wing Inn ',
          alt: 'Fachada exterior del Blue Wing Inn ',
        },
        p: `Al lado, <b>Casa de Billar</b>, una divertida sala de billares, fue nuestro primer establecimiento de apuestas.  `,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/3.png',
          mobileUrl: '../../../assets/stop7/3.png',
          footnote: 'Cuadro “Tertulia de Pulquería” por Agustín Arrieta (1851)',
          alt: 'Cuadro “Tertulia de Pulquería” por Agustín Arrieta (1851)',
        },
        p: `Sonoma cambió casi de la noche a la mañana con el inicio de la Fiebre del Oro haciendo del alcohol y las apuestas los pasatiempos favoritos. Los ricos mineros usualmente pagaban con partículas de oro.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/4.png',
          mobileUrl: '../../../assets/stop7/4.png',
          footnote: 'Ilustración: Conrad Reed encuentra oro…Harper’s New Monthly Magazine (1857)',
          alt: 'Ilustración: Conrad Reed encuentra oro…Harper’s New Monthly Magazine (1857)',
        },
        p: `Kids, like the Cooper boys who lived at the Blue Wing Inn, would wash the floor to see what the miners would leave behind.`,
        pt: 3,
      },
      {
        title: 'Los bares surgieron y se trasladaron alrededor de la Plaza.',
        pt: 3,
      },
      {
        p: `El <b>Pioneer</b> comenzó como una tienda general y se trasladó a Napa St. luego de regreso a Spain St., añadiendo un segundo piso y actualmente es una casa. `,
        pt: 3
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/5.png',
          mobileUrl: '../../../assets/stop7/5.png',
          footnote: 'Bar Pioneer y tienda Miller & Pauli. Sonoma, CA, 1870s. Cortesía de la Biblioteca del Condado de Sonoma.',
          alt: 'Bar Pioneer y tienda Miller & Pauli. Sonoma, CA, 1870s. Cortesía de la Biblioteca del Condado de Sonoma.',
        },
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/6.png',
          mobileUrl: '../../../assets/stop7/6.png',
          footnote: 'Una visitante disfrutando un vino en El Dorado Kitchen and Hotel',
          alt: 'Una visitante disfrutando un vino en El Dorado Kitchen and Hotel',
        },
      },
      {
        list: {
          title: 'Aún hoy en día puedes disfrutar un trago en estos historicos establecimientos ',
          values: [
            `El Dorado`,
            `El Swiss `
          ]
        }
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/7.png',
          mobileUrl: '../../../assets/stop7/7.png',
          footnote: 'Fachada del edificio histórico donde se ubica Taub Outpost',
          alt: 'Fachada del edificio histórico donde se ubica Taub Outpost',
        },
        p: `Observa a tu alrededor. Estás posiblemente a pocos pasos de un excelente coctel o una deliciosa copa de vino.`,
        pt: 3,
      },
      {
        quiz: {
          question: '¿Cuál fue el primer bar en Sonoma?',
          choices: [
            {
              choice: 'Pioneer',
              answer: false,
            },
            {
              choice: 'Casa de Billar',
              answer: false,
            },
            {
              choice: 'Blue Wing Inn',
              answer: true,
            },
          ],
        },
      },
    ],
    [
      {
        location: 'Signo de la tienda del oso',
        pt: 3,
      },
      {
        title: 'signo del oso',
        pt: 3,
      },
      {
        p: `Durante la <b>Fiebre del Oro</b>, más de 300,000 personas invadieron California de todas partes del mundo - Europa, Centro y Sur América, Australia y China. `,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          lottieImg: true,
        },
        pt: 3,
      },
      {
        timebar: {
          date: "1850's",
          title: 'Buscando Fortuna',
        },
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/2.png',
          mobileUrl: '../../../assets/stop8/2.png',
          footnote: 'William Shew. Desertor en San Francisco. Ca. 1852.',
          alt: 'William Shew. Desertor en San Francisco. Ca. 1852.',
        },
        pt: 3,
      },
      {
        p: `Jóvenes chinos navegaron a través del Pacífico en busca de fortuna en <b>Gam Saan, o "Montaña de Oro.”</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/3.png',
          mobileUrl: '../../../assets/stop8/3.png',
          footnote: 'Los mineros chinos usaron recogedores de piedra (también llamados horquillas) para tamizar el material en busca de oro durante la Fiebre del Oro de California.  ',
          alt: 'Los mineros chinos usaron recogedores de piedra (también llamados horquillas) para tamizar el material en busca de oro durante la Fiebre del Oro de California.  ',
        },
        pt: 3,
      },
      {
        p: `Solo unos pocos alcanzaron la riqueza y otros encontraron trabajo en <b>agricultura y construyendo el ferrocarril.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/4.png',
          mobileUrl: '../../../assets/stop8/4.png',
          footnote: 'Hombre chino (c. 1853. Cortesía: Museo de Oakland en California',
          alt: 'Hombre chino (c. 1853. Cortesía: Museo de Oakland en California',
        },
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/5.png',
          mobileUrl: '../../../assets/stop8/5.png',
          footnote: "Trabajadores chinos del ferrocarril",
          alt: 'Trabajadores chinos del ferrocarril',
        },
        pt: 3,
      },
      {
        timebar: {
          date: '1860-1870',
          title: 'Gran Aumento en la Población',
        },
        pt: 3,
      },
      {
        p: `Para los 1860 <b>cientos trabajaban en ranchos</b> alrededor de Sonoma. Los jefes de cellar chinos supervisaban la <b>elaboración de vinos.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/6.png',
          mobileUrl: '../../../assets/stop8/6.png',
          footnote: 'Ho Po: Cortesía de Sonoma Index Tribune',
          alt: 'Ho Po: Cortesía de Sonoma Index Tribune',
        },
        pt: 3,
      },
      {
        p: `Para 1870, cerca del <b>25% de la población</b> de Sonoma era china.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/8.png',
          mobileUrl: '../../../assets/stop8/8.png',
          footnote: 'Hi-Lo House. Cortesía: Sonoma Valley Sun',
          alt: 'Hi-Lo House. Cortesía: Sonoma Valley Sun',
        },
        pt: 3,
      },
      {
        p: `Hop Wo manejaba “Hi-Lo House,”en la Plaza, una combinación de lavandería, tienda y oficina de empleos. Estaba cerca del actual Sign of the Bear.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/9.png',
          mobileUrl: '../../../assets/stop8/9.png',
          footnote: 'Sign of the Bear',
          alt: 'Sign of the Bear',
        },
        pt: 3,
      },
      {
        p: `Otros negocios y viviendas chinas estaban concentradas alrededor del Sonoma Hotel.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/10.png',
          mobileUrl: '../../../assets/stop8/10.png',
          footnote: 'Mapa de Seguro Contra Incendios Sanborn (1888)',
          alt: 'Mapa de Seguro Contra Incendios Sanborn (1888)',
        },
        pt: 3,
      },
      {
        p: `Los vecinos del siglo diez y nueve recuerdan como <b>“uno podía oir el sonido de los banjos chinos y cometas musicales atadas con bandas de caucho silbando con el viento”</b> tsobre la gran Plaza abierta, que aún no tenía árboles plantados.`,
        pt: 3,
      },
      {
        timebar: {
          date: "Finales de los 1870",
          title: 'Racismo Contra los Chinos',
        },
        pt: 3,
      },
      {
        p: `Para finales de los 1870, el racismo contra los chinos llevó a discriminación y violencia.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/11.png',
          mobileUrl: '../../../assets/stop8/11.png',
          footnote: '1882. Cortesía: Biblioteca del Congreso [Nueva York] : [Frank Leslie], 1882. Cortesía: Biblioteca del Congreso.jpg]',
          alt: '1882. Cortesía: Biblioteca del Congreso [Nueva York] : [Frank Leslie], 1882. Cortesía: Biblioteca del Congreso.jpg]',
        },
        pt: 3,
      },
      {
        p: `Las leyes estatales hicieron <b>ilegal que ellos fueran propietarios</b>, que trajeran a sus esposas y familias, o hasta que sus restos fueran enviados a la China. A causa de semejante prejuicio, la <b>comunidad china de Sonoma desapareció.</b> Lo que fue un grupo vibrante en nuestra cultura local ha sido casi totalmente borrado, dejando una herida casi invisible.`,
        pt: 3,
      },
      {
        p: '<b>Ellos no han sido olvidados.</b>'
      },
      {
        quiz: {
          question: '¿Cuándo sucedió la discriminación?',
          choices: [
            {
              choice: 'Principios de los 1870',
              answer: false,
            },
            {
              choice: 'Mediados de los 1860',
              answer: false,
            },
            {
              choice: 'Finales de los 1870',
              answer: true,
            },
          ],
        },
      },
    ],
    [
      {
        videoplay: {
          title: 'Esta parada incluye reproducción de video.',
          p: 'Presta atención a lo que te rodea mientras lo miras.',
          videoTitle: 'El Lago de Patos',
          videoContent: 'Este video es una introducción al preciado Lago de Patos de Sonoma y su significado. Este lago, hecho por el hombre, resuena con el paisaje de Sonoma.',
          videoFooter: 'Video: Lago de Patos',
          videoImageLink: '../../../assets/stop9/1.png',
          videoLink: "https://www.youtube.com/embed/6HGqTumAEx4"
        },
        pt: 3,
      },
      {
        quiz: {
          question: '¿Quién llamó a Sonoma Fuente de Fuentes?',
          choices: [
            {
              choice: 'General Mariano Vallejo',
              answer: false,
            },
            {
              choice: 'Desconocido',
              answer: false,
            },
            {
              choice: 'Padre Altimira',
              answer: true,
            },
          ],
        },
      },
    ],
    [
      {
        location: "Picnic Area",
        pt: 3
      },
      {
        audioPlay: {
          title: 'Esta parada incluye reproducción de audio.',
          p: 'Presta atención a lo que te rodea mientras escuchas.',
        },
        pt: 3,
      },
      {
        p: '<b>Billy Lynch</b>',
        pt: 3
      },
      {
        p: `Bill Lynch recuerda la Plaza cuando él era niño en los 1950s.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop10/1.png',
          mobileUrl: '../../../assets/stop10/1.png',
          footnote: 'Foto de Bill Lynch contando su historia',
          alt: 'Foto de Bill Lynch contando su historia',
        },
        pt: 3,
      },
    ],
  ];

  export const LOTTIEANIMATION = {
    'title': 'Detectando tu ubicación…',
    'content': 'Sonoma Plaza History usa GPS para ayudarlo a navegar'
  }

  export const TRACKLOCATION = {
    'title': 'No pudimos localizar su ubicación GPS.',
    'content': 'Todavía puedes disfrutar del recorrido sin el GPS habilitado.',
    'btnContent': 'Continuar sin GPS activado',
    'linkContent': 'Aprenda a habilitar los servicios de ubicación GPS para su dispositivo '
  }

  export const WELCOMEMAP = {
    'title': 'Consejos para ayudarte',
    'content': 'Escoge “He llegado” si el destino no carga automáticamente',
    'btnContent': 'Lo entiendo',
  }

  export const WELCOMETOURSTOP = {
    "title":"Bienvenido a la primera parada del tour.",
    "content1":"Muchas de las paradas de la gira tienen contenido como reproducción de audio, video, texto e imágenes." ,
    "content2":"Presione reproducir (cuando corresponda) y desplácese o deslice para ver contenido adicional.",
    'btnContent': 'Lo entiendo',
  }